var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","small":""},on:{"click":_vm.onClickDarkMode}},[_c('v-icon',{attrs:{"color":_vm.iconTheme}},[_vm._v(" "+_vm._s(_vm.iconSource)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }